// Zero-grant landing page.
//
// Shown to a signed-in user who has not been granted any dashboard section
// yet (and reached by any deep link that resolves to no accessible section —
// see firstGrantedPath in App.tsx). The server is the real guard; this is the
// friendly "ask an admin" surface. Uses the shared EmptyState atom.

import { Card, EmptyState } from "../lib/theme";

export default function NoAccess() {
  return (
    <Card>
      <EmptyState
        title="No access yet"
        hint="Ask David to grant you a section."
      />
    </Card>
  );
}
